import axios from 'axios';
import { generateRequestHeader } from '@/utils/axiosUtils';
import { encryptJsonToQ } from '@/utils/crypto_helpers';
import { setupAuditInterceptor } from './auditInterceptor';

const latin1Safe = (s: string) => s.replace(/[^\x00-\xFF]/g, '');

const createHttp = (url: string) => {
	const instance = axios.create({ baseURL: url });
	setupAuditInterceptor(instance);

	const auditData = localStorage.getItem('auditUser') || '{}';
	instance.interceptors.request.use(
		async (config) => {
			// Set request headers
			config.headers['x-ref-id'] = encodeURI(await generateRequestHeader(1));

			if (auditData) {
				const auditJson =
					typeof auditData === 'string' ? auditData : JSON.stringify(auditData);
				config.headers['x-audit-user'] = latin1Safe(auditJson);
			}

			// Persist last axios request info for Sentry beforeSend enrichment
			try {
				window.lastAxiosHeaders = {
					method: config?.method,
					url: config?.url || '',
					headers: config?.headers,
				};
			} catch (e) {
				console.warn('Unable to store Sentry request metadata:', e);
			}

			// Encrypt query params for GET requests
			const method = (config.method || 'get').toLowerCase();

			if (method === 'get' && config.params) {
			 // Put everything into one encrypted param
			 const queryHashed = await encryptJsonToQ(config.params);
			 config.params = { queryHashed, qv: 1 }; // qv = version
			}

			return config;
		},
		(error) => {
			return Promise.reject(error);
		},
	);

	return instance;
};

export default createHttp;
 